import React, { useCallback, useEffect, useMemo, useState } from "react";
import { CLASSROOM_PLAN, CLASSROOM_PLAN_PREVIEW, CLASSROOM_SERVICES_ADD, CLASSROOM_SERVICES_EDIT, CLASSROOM_SERVICESd_Detail, EDIT_SCHOOL_CLASSROOM_PLAN, SCHOOL_CLASSROOM_PLAN } from "config/paths";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import styles from "./myfavorite.module.scss";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { useDeleteClassroomConsultationMutation, useDeleteClassroomReportMutation, useFavouriteReportMutation, useGetClassroomConsultationListQuery, useGetClassroomReportsListQuery } from "store/services/classroom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { CommonSelect, CommonToolTip, CstmPagination } from "components/Common/Common";
import { useAssignedSchoolsLookupQuery, useDivisionLookupQuery, useLazyAssignedSchoolsLookupQuery, useLazyGetFileUrlQuery, useLazySchoolLookupQuery } from "store/services/utility";
import { DeleteIcon, EditIcon, EyeOpenIcon, FileIcon } from "Assets/icons";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { cloneDeep, debounce } from "lodash";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { convertToMomentDate, dateFormat, successMessageToast, userFullName } from "helpers/common";
import { classroomReportStatusOptions, GRADE_OPTIONS, REPORT_IDS, reportDateFormat } from "config/constants";
import SearchListCheckbox from "components/shared/SearchListCheckbox";
import ClassroomReportsModal from "components/Modals/ClassroomReportsModal";
import { ArrowDown, ArrowUp, Star } from "react-feather";
import confirmDialogV2 from "utils/confirmationDialogV2";
import { useCreateClassroomReportCopyMutation, useStartClassroomReportMutation } from "store/services/clients/reports-v2/classroomReport";
import moment from "moment";
import TableHeaderV2 from "components/shared/FormComponents/TableHeaderV2";
import ClassroomReportDateModal from "components/Modals/ClassroomReportDateModalV2";
import rightArrow from "../../Assets/images/rightArro.png"
import downArrow from "../../Assets/images/downArro.png"

const ClassRoomReports = () => {

  const navigate = useNavigate();

  const [openRow, setOpenRow] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({ search: "", school: "", grade: "", status: "", sort: { column: "id", direction: "desc" } });
  const [schoolOptionList, setSchoolOptionList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [reportsModal, setReportsModal] = useState(false)
  const [consultationList, setConsultationList] = useState([]);
  const assessmentId = 12

  const { data, isLoading, isError, isFetching, refetch } = useGetClassroomReportsListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const [favouriteReport, { isLoading: favouriteReportLoading }] = useFavouriteReportMutation()
  const [getSchools, { isFetching: schoolsLoading }] = useLazyAssignedSchoolsLookupQuery()
  const [copyReportDateModal, setCopyReportDateModal] = useState(false)

  const [deleteConsultation, { isLoading: deleteConsultationLoading }] = useDeleteClassroomConsultationMutation();
  const [copyReport, { isLoading: copyReportLoading }] = useCreateClassroomReportCopyMutation()
  const [deleteReport, { isLoading: deleteReportLoading }] = useDeleteClassroomReportMutation()
  const [startNewReport, { isLoading: startNewReportLoading }] = useStartClassroomReportMutation()

  const getSchoolOptions = async (search) => {
    try {

      const result = await getSchools(search);
      if (result?.data?.[0]?.id) {
        const data = result?.data?.map((item) => ({ label: item?.name, value: item?.id }))
        setSchoolOptionList(data);
      }
    } catch (error) { console.log("Error Getting school options"); };

  };


  const handleSearch = useCallback(debounce((value) => {
    if (value) getSchoolOptions(value);
  }, 500), []);

  const resetFilter = () => {
    setFilter({ search: "", school: "", grade: "", status: "", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleDelete = async () => {
    try {

      setShowModal(false);
      const list = cloneDeep(consultationList);
      const index = list.findIndex(x => x.id == currentEntry?.id);
      if (index > -1) delete list[index];
      setConsultationList(list?.filter(Boolean));

      const result = await deleteConsultation(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error deleting classroom consultation", err);
    };
  };

  const handleFavouriteReport = async (report_id, favourite) => {
    const data = {
      report_id,
      favorite: favourite
    }
    try {
      await favouriteReport({ data }).unwrap()
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleCopyReport = async (e, reportId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "MAKE A COPY",
      message: `A copy of this report will be added to your list with ${moment().format(reportDateFormat)} as the Report Date.`,
    });
    if (!isConfirm) {
      setCopyReportDateModal(true)
      return
    }
    else {
      handleCopyReportApi(reportId, moment(new Date()).format("YYYY-MM-DD"))
    }
  }

  const handleCopyReportApi = async (reportId, screening_date) => {
    try {
      await copyReport({ assessmentId, reportId, screening_date }).unwrap()
      refetch()
      if (copyReportDateModal) {
        setCopyReportDateModal(false)
      }
    } catch (error) {
      console.log('error making copy of report', error)
    }
  }

  const handleDeleteReport = async (e, reportId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "DELETE REPORT",
      message: "Are you sure you want to delete this report?",
    });
    if (!isConfirm) {
      return;
    }

    try {
      await deleteReport({ reportId }).unwrap()
      refetch()
    } catch (error) {
      console.log('error deleting report', error)
    }
  }

  const handleStartReport = async () => {
    try {
      const response = await startNewReport().unwrap()
      navigate(generatePath(EDIT_SCHOOL_CLASSROOM_PLAN, { reportId: response?.data?.preflightReportsId }))
      refetch()
    } catch (error) {
      console.log('error starting report', error)
    }
  }

  const toggleRow = (id) => setOpenRow(openRow === id ? null : id);

  const columns = [
    {
      head: <div onClick={() => setFilter((prev) => ({ ...prev, sort: prev?.sort?.column == "is_favorite" ? { column: "id", direction: "desc" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
      accessor: "is_favorite",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteReport(item?.id, item?.is_favorite ? 0 : 1) }}>{item?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
      ),
    },
    {
      head: "Date",
      accessor: "screening_date",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 text-capitalize d-flex align-items-center gap-2">{dateFormat(item?.screening_date, reportDateFormat) || "--"}</h6>
      ),
    },
    {
      head: "Class",
      accessor: "report_classname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div className="text-capitalize fw-bold">{item?.report_classname || "--"}</div>
      ),
    },
    {
      head: "Teacher",
      accessor: "teacher",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div className="text-capitalize fw-bold">{userFullName(item?.reportsPreflightTeacher) || "--"}</div>
      ),
    },
    {
      head: "Age",
      accessor: "report_age_range",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 ">{item?.report_age_range || "--"}</h6>
      ),
    },
    {
      head: "Grade",
      accessor: "report_grade",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 ">{item?.report_grade || "--"}</h6>
      ),
    },
    {
      head: "School",
      accessor: "school",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div className="text-capitalize">{item?.reportsPreflightSchool?.name || "--"}</div>
      ),
    },
    {
      head: "Status",
      accessor: "status",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        item?.status === "complete" ? (
          <div className="text-capitalize"><strong>Published</strong></div>
        ) : item?.status === "copied" ? (
          <div className="text-capitalize">{"Copy" || "--"}</div>
        ) : item?.status === "in-progress" ? (
          <div style={{ fontStyle: "italic" }} className="text-capitalize">{"In progress" || "--"}</div>)
          : <div className="text-capitalize">{item?.status || "--"}</div>

      ),
    },
    // {
    //   head: "Status",
    //   accessor: "status",
    //   sorter: true,
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <p
    //       style={{ width: 80 }}
    //       className={`${item?.status == "pending"
    //         ? "redStatus"
    //         : "greenStatus"
    //         } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
    //     >
    //       {item?.status}
    //     </p>
    //   ),
    // },
    {
      // head: "Action",
      accessor: "",
      isComponent: true,
      // sorter: true,
      component: (item, index) => (
        item?.status !== "complete" && 
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Dropdown
            onClick={(e) => e.stopPropagation()}
          // show={index == dropdownIndex}
          // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
          >
            <Dropdown.Toggle
              variant="transparent"
              className="p-0 border-0 text-dark w-100"
              id="dropdown-basic"
            >
              <span className="icn ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="13"
                  viewBox="0 0 28 13"
                  fill="none"
                >
                  <rect width="28" height="13" rx="6.5" fill="" />
                  <path
                    d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                    fill="#315D99"
                  />
                  <path
                    d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                    fill="#315D99"
                  />
                  <path
                    d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                    fill="#315D99"
                  />
                </svg>
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
              <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                {
                  item?.status !== "complete" && <h5 className="cursor-pointer proxima mb-2" onClick={(e) => { handleCopyReport(e, item?.id); setCurrentEntry(item) }} style={{ borderBottom: "0.5px solid #000", padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Make a Copy</h5>
                }
                {
                  item?.status !== "complete" && <h5 className="cursor-pointer proxima mb-2" onClick={(e) => handleDeleteReport(e, item?.id)} style={{ borderBottom: item?.pdfList?.[0]?.attachment_key && "0.5px solid #000", padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Delete Report</h5>
                }
                {
                  item?.pdfList?.[0]?.attachment_name &&
                  <h5 className="cursor-pointer proxima mb-2" onClick={(e) => handleViewPdf(item?.pdfList?.[0]?.attachment_key)} style={{ padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>View PDF</h5>
                }
              </ul>
            </Dropdown.Menu>
          </Dropdown>

          {
            item?.status == "complete" && <div
              className="cursor-pointer d-flex align-items-center"
              style={{ padding: "10px 10px" }}
              onClick={(e) => {
                e.stopPropagation(); // prevent row navigation
                toggleRow(item.id);
              }}
            >
              {openRow === item.id ? (
                <img width={12} src={downArrow} alt="Collapse" />
              ) : (
                <img width={7} src={rightArrow} alt="Expand" />
              )}
            </div>
          }
        </div>
      ),
    },
  ];
  const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

  // const { data: consentFormList, error, isLoading: consentFormListLoading } = useGetConsentformListQuery({ client_id: clientId });

  const handleViewPdf = async (name) => {

    try {
      const result = await getFileUrl(name);
      if (result?.error) return;

      const url = result?.data
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };

  useEffect(() => {
    getSchoolOptions();
  }, []);

  useEffect(() => {
    if (data?.records) setConsultationList(data?.records || []);
  }, [data]);

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDelete}
        type="delete"
      />
      {/* <ClassroomReportsModal
        show={reportsModal}
        setShow={setReportsModal}
        currentEntry={currentEntry}
      /> */}
      <ClassroomReportDateModal
        show={copyReportDateModal}
        setShow={setCopyReportDateModal}
        currentEntry={currentEntry}
        handleCopyReportApi={handleCopyReportApi}
        isLoading={copyReportLoading}
      />
      <section className="client proxima position-relative py-4">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left classroom-conslutation">
                  <h6 className="m-0 fw-bold main-head themeBlue">Classroom Consultation</h6>
                  {/* <TableHeaderV2
                    heading={"Classroom Consultation"}
                    filter={filter}
                    handleFilterChange={handleFilterChange}
                    resetFilter={resetFilter}
                    searchPlaceholder="Title"
                    hideSearch
                    // hideFilters
                    filterComponent={
                      <>
                        <li>
                          <CommonSelect
                            placeholder={"Select School"}
                            option={schoolOptionList}
                            onChange={(e) => handleFilterChange("school")(e)}
                            value={filter?.school}
                            onInputChange={(val) => handleSearch(val)}
                            isFilterV2
                          // isLoading={schoolListLoading || schoolListFetching}
                          />
                        </li>
                        <li>
                          <CommonSelect
                            placeholder={"Select Status"}
                            option={classroomReportStatusOptions}
                            onChange={(e) => handleFilterChange("status")(e)}
                            value={filter?.status}
                            isFilterV2
                          // isLoading={schoolListLoading || schoolListFetching}
                          />
                        </li>
                      </>
                    }
                  /> */}
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <button
                        // to={SCHOOL_CLASSROOM_PLAN}
                        onClick={() => handleStartReport()}
                        className="blue-discharge-screen-btn mt-0 d-flex align-items-center justify-content-center"
                      >
                        New Consultation Plan
                      </button>
                    </li>
                  </ul>
                </div>
              </div>

              <Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
                <Col md='4'>
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">School</label>
                    <CommonSelect
                      placeholder={"Select School"}
                      option={schoolOptionList}
                      onChange={(e) => handleFilterChange("school")(e)}
                      value={filter?.school}
                      onInputChange={(val) => handleSearch(val)}
                      isFilterV2
                      isClearable
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                      isLoading={schoolsLoading}
                    />
                  </div>
                </Col>
                <Col md='3'>
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Status</label>
                    <CommonSelect
                      placeholder={"Select Status"}
                      option={classroomReportStatusOptions}
                      onChange={(e) => handleFilterChange("status")(e)}
                      value={filter?.status}
                      isFilterV2
                      isClearable
                      // isLoading={schoolListLoading || schoolListFetching}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <div className="table-outer classroom-consultation">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : consultationList?.length ? (
                  <>
                    {(isFetching || deleteConsultationLoading || favouriteReportLoading || copyReportLoading || deleteReportLoading || startNewReportLoading) && <LoadingOverlay />}
                    <TableLayout
                      data={consultationList || []}
                      column={columns}
                      filter={filter}
                      url={EDIT_SCHOOL_CLASSROOM_PLAN.replace("/:reportId", "")}
                      handleSort={handleFilterChange("sort")}
                      expandableRowComponent={(row) => {
                        let emailData = {};
                        try {
                          emailData = JSON.parse(row?.emailFormData || '{}');
                        } catch (error) {
                          console.error('Invalid JSON in emailFormData', error);
                        }
                        const date = moment(row?.publishedAt).format("MMM DD, YYYY");
                        const time = moment(row?.publishedAt).format("h:mm A");
                        return (
                          <div style={{ borderTop: "0.25px solid #00000036", paddingTop: "8px" }} className="d-flex gap-3 justify-content-between">
                            <table style={{ width: "70%", borderCollapse: "separate", borderSpacing: "0 6px" }}>
                              <tbody>
                                <tr className="border-0">
                                  <th className="border-0 p-0 text-left">Dashboard:</th>
                                  <td className="border-0 p-0">Teacher</td>
                                </tr>
                                <tr className="border-0">
                                  <th className="border-0 p-0 text-left">Email Recipient:</th>
                                  <td className="border-0 p-0">
                                    {
                                      emailData?.recipientList?.map(item => `${item?.email} `)
                                    }
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <div className="text-end d-flex text-gray-500" style={{ width: "30%", gap: "30px", paddingTop: "6px" }}>
                              <p>{date}</p>
                              <p>{time}</p>
                            </div>
                          </div>
                        )
                      }}
                      toggleRow={toggleRow}
                      openRow={openRow}
                    />
                    <CstmPagination
                      totalPages={totalPages}
                      activePage={currentPage}
                      className="paginationV2"
                      handlePageChange={handlePageChange}
                    />
                    {/* <TableWithAccordion /> */}
                  </>
                ) : (
                  <div className="classroom-no-reports mt-5">
                    <p>Looks like you don't have any classroom consultations in progress yet. Your list of these reports will appear here.</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ClassRoomReports;


const TableLayout = ({ openRow, toggleRow, expandableRowComponent, column, data, url, showHeader = true, noDataMsg = "Data not found", state, filter, handleRowClick, height, handleSort }) => {
  const navigate = useNavigate();
  const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

  // const { data: consentFormList, error, isLoading: consentFormListLoading } = useGetConsentformListQuery({ client_id: clientId });

  const handleSortClick = (item) => {

    let sort = {};
    console.log('filter sort and item?.accessor', filter, item?.accessor)
    if (filter?.sort?.column == item?.accessor) {

      if (filter?.sort?.direction == "asc") sort = { column: item?.accessor, direction: "desc" };
      else sort = { column: "id", direction: "desc" };

    } else sort = { column: item?.accessor, direction: "asc" }

    typeof handleSort === "function" && handleSort(sort);
  };

  const handleViewPdf = async (name) => {

    try {
      const result = await getFileUrl(name);
      if (result?.error) return;

      const url = result?.data
      if (url) window.open(url, '_blank');

    } catch (err) { console.error("Error assigning therapist", err); }
  };



  return (
    <div className="favorite-goal-wrapper classroom-consultation proxima table_height" style={{ height: height || "calc(100vh - 220px)" }}>
      {
        getFileFetching && <LoadingOverlay />
      }
      <div className={`${styles.tableResponsive} table-responsive mb-3 h-100`}>
        <table className={`${styles.table} table`}>
          {showHeader && (
            <thead>
              <tr className="">
                {column &&
                  column.length > 0 &&
                  column.map((item, key) => (
                    <>
                      <th className="text-dark border-0" style={{ fontWeight: 500 }}>
                        <div className="d-flex">
                          {item.head}
                          {
                            item?.sorter && <div className="px-2 cursor-pointer d-flex flex-column justify-content-center" onClick={() => handleSortClick(item)}>
                              {filter?.sort?.column == item?.accessor && filter?.sort?.direction == "asc" ? <ArrowUpFilled /> : <ArrowUpOutline />}
                              {filter?.sort?.column == item?.accessor && filter?.sort?.direction == "desc" ? <ArrowDownFilled /> : <ArrowDownOutline />}
                            </div>
                          }
                        </div>
                      </th>
                    </>
                  ))}
              </tr>
            </thead>
          )}
          <tbody>
            {data && data.length > 0 ? (
              data.map((row, idx) => (
                <React.Fragment key={row.id || idx}>
                  {/* Main Row */}
                  <tr
                    className={`${url ? "cursor-pointer" : ""}`}
                    onClick={(e) => {
                      if (row?.pdfList?.[0]?.attachment_key)
                        handleViewPdf(row?.pdfList?.[0]?.attachment_key);
                      else {
                        url && navigate(`${url}/${row.id}`, { state });
                        handleRowClick?.(row);
                      }
                    }}
                  >
                    {column?.map((item, key) => (
                      <td
                        key={key}
                        className={`${row?.status === "copied"
                          ? "copied-report-bcg"
                          : row?.status === "complete" && "published-report-bcg"
                          } ${openRow == row?.id && 'border-bottom-0 rounded-bottom-0'} `}
                      >
                        {item.component
                          ? item.component(row, idx, row)
                          : row[item?.accessor] || "--"}
                      </td>
                    ))}
                  </tr>

                  {/* Expanded Row */}
                  {expandableRowComponent && openRow === row.id && (
                    <tr style={{ position: 'relative', top: "-10px" }}>
                      <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={2}></td>
                      <td className={`${openRow == row?.id && 'border-top-0 rounded-top-0'}`} style={{ background: "#F5F5F5" }} colSpan={7}>
                        {expandableRowComponent(row)}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan={column?.length || 1} className="text-center">
                  {noDataMsg}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};



const ArrowUpFilled = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-up-fill"
      viewBox="0 0 16 16"
    >
      <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
    </svg>
  )
};

const ArrowDownFilled = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-down-fill"
      viewBox="0 0 16 16"
    >
      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
    </svg>
  )
}

const ArrowDownOutline = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-down"
      viewBox="0 0 16 16"
    >
      <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659" />
    </svg>
  )
}

const ArrowUpOutline = () => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      fill="currentColor"
      class="bi bi-caret-up"
      viewBox="0 0 16 16"
    >
      <path d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659" />
    </svg>
  )
}